export default __webpack_public_path__ + "static/media/risk-identification-2.55a140c1.svg";